
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/transparency-supply-chains",
      function () {
        return require("private-next-pages/about/transparency-supply-chains.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/transparency-supply-chains"])
      });
    }
  